import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=0f675014&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=ts"
export * from "./UserMenu.vue?vue&type=script&lang=ts"
import style0 from "./UserMenu.vue?vue&type=style&index=0&id=0f675014&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f675014",
  null
  
)

export default component.exports